export enum ImageTransformations {
    SQR32 = "sqr_32",
    SQR40 = "sqr_40",
    SQR48 = "sqr_48",
    SQR56 = "sqr_56",
    SQR64 = "sqr_64",
    SQR96 = "sqr_96",
    SQR128 = "sqr_128",
    SQR223 = "sqr_223",
}
